<mat-card class="batch-list-container">
    <div class="row">
        <div class="col-md-2">
            <mat-card-title>Batches</mat-card-title>
        </div>
        <div class="col-md-10 text-end">
            <form [formGroup]="filterBatchesForm">
                <mat-form-field class="me-2" appearance="outline">
                    <mat-label>Search using batch number</mat-label>
                    <input matInput formControlName="batchNumber" placeholder="Start typing...">
                    <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>

                <mat-form-field class="me-2" appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="batchStatus">
                        <mat-option [value]="status" *ngFor="let status of batchStatuses">
                            {{status.status}}
                        </mat-option>
                    </mat-select>
                    <button *ngIf="selectedBatchStatus" (click)="resetStatus()" mat-icon-button matSuffix
                        [attr.aria-label]="'Remove status'">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-form-field>

                <mat-form-field class="me-2" appearance="outline">
                    <mat-label>Search for medicine</mat-label>
                    <input required [disabled]="isLoading" data-testid="add-medicine-name" type="text"
                        placeholder="Search for medicine" aria-label="Search for medicine" matInput
                        formControlName="medicineName" [matAutocomplete]="auto">
                    <mat-autocomplete data-testid="medicine-autocompletion-list"
                        (optionSelected)="medicineSelected($event)" autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option *ngFor="let med of medicine" [value]="med">
                            {{med.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matPrefix>search</mat-icon>
                    <button *ngIf="selectedMedicine" (click)="resetMedicine()" mat-icon-button matSuffix
                        [attr.aria-label]="'Remove medicine'">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-form-field>
            </form>
        </div>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 15, 20]" [pageIndex]="page-1" [pageSize]="limit"
        [length]="totalNumberOfBatches" showFirstLastButtons (page)="onPageChange($event)"
        aria-label="Select page of prescriptions">
    </mat-paginator>

    <div class="py-2">
        <mat-divider></mat-divider>
    </div>
    <table mat-table [dataSource]="batchesDataSource" class="batch-list">
        <ng-container matColumnDef="id">
            <th class="px-2" mat-header-cell *matHeaderCellDef>#</th>
            <td class="px-2" mat-cell *matCellDef="let batch"> {{batch.id}} </td>
        </ng-container>
        <ng-container matColumnDef="batch_number">
            <th mat-header-cell *matHeaderCellDef>Batch number</th>
            <td mat-cell *matCellDef="let batch">{{ batch.batch_number }}</td>
        </ng-container>

        <ng-container matColumnDef="medicine">
            <th mat-header-cell *matHeaderCellDef>Medicine</th>
            <td mat-cell *matCellDef="let batch">{{ batch.medicine_dosage_type.medicine.name }}</td>
        </ng-container>

        <ng-container matColumnDef="quantity_produced">
            <th mat-header-cell *matHeaderCellDef>Quantity produced</th>
            <td mat-cell *matCellDef="let batch">
                {{getQuantityProduced(batch)}}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let batch">
                <span *ngIf="batch.status" class="badge {{getBadgeBackground(batch.status)}}">{{ batch.status.status }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td mat-cell *matCellDef="let batch"> {{getCreationTime(batch)}} </td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
            <th mat-header-cell *matHeaderCellDef>Updated</th>
            <td mat-cell *matCellDef="let batch"> {{formatTime(batch.updated_at)}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row (click)="openBatch(row.id)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</mat-card>